<template>
    <div>
    </div>
</template>

<script>
export default {
  components: {
  },
  methods: {
    handleLoginEvent(data) {
      this.$router.push(data.state.target || '/Createbooking');
    },
  },
  created() {
    this.$auth.handleAuthentication();
  },
};
</script>